import React, { useState } from "react";
import { Breadcrumb, Button, Col } from "react-bootstrap";
import { PlusIcon } from "../../../components/ui/icons";
import CreateDAS from "./createDas";
import { useCreateDasAlertNotification } from "./useDas";
import ListDas from "./listDas";
import { Link } from "react-router-dom";
import { routes } from "../../../common/constants";
import "./das.scss";

const Das = () => {
  const [show, setshow] = useState(false);
  const handleShow = () => setshow(!show);

  useCreateDasAlertNotification();
  return (
    <div className="integration-container">
      <div className="integration-header">
        <div className="integration-header-content">
          <div className="integration-heading">3rd Party Integration</div>
          <div className="integration-config-btn">
            {!show ? (
              <Button className="buttonLight" onClick={handleShow}>
                <PlusIcon /> Configure Another Set
              </Button>
            ) : null}
          </div>
        </div>
        <Col>
          <div className="integration-breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item linkAs={Link} linkProps={{ to: `${routes.integrations}` }}>
                3rd Party Integration
              </Breadcrumb.Item>
              <Breadcrumb.Item active>DAS Configuration</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>
        <Col sm={8}>
        </Col>
      </div>

      <div className="integration_accordian">
        {!show ? <ListDas /> : null}

        {show ? <CreateDAS handleShow={handleShow} /> : null}
      </div>
    </div>
  );
};

export default Das;
